export const EVENT_ACTIONS = {
  ATTRIBUTE_SORT: 'attributeSort',
  ATTRIBUTE_SORT_SET: 'attributeSortSet',
  ATTRIBUTE_SORT_ONLY_POSITIONS: 'attributeSortOnlyPositions',
  ATTRIBUTE_ADD: 'attributeAdd',
  ATTRIBUTE_DELETE: 'attributeDelete',
  ATTRIBUTE_REPLACE: 'attributeReplace',
  ATTRIBUTE_METRICS_CHANGE: 'attributeMetricsChange',
  PRESET_CHANGE: 'presetChange',
  TRACK_TARGET_CHANGE: 'trackTargetChange',
  TRACK_ATTRIBUTES_CHANGE: 'trackAttributesChange',
  CURRENT_SPLIT_CHANGE: 'currentSplitChange',
  SWAP_CHANGE: 'swapChange',
  ITEM_SELECT: 'itemSelect',
  ITEM_REPLACE: 'itemReplace',
  ITEM_ADD: 'itemAdd',
  ITEM_PIN: 'itemPin',
  ITEM_DELETE: 'itemDelete',
  ITEM_ORDER_MANUAL: 'itemOrderManual',
  ITEM_DRAG_TRACK_STATE: 'itemDragTrackState',
  ITEM_DRAG_LISTEN_STATE: 'itemDragListenState',
  WAVE_CHANGE: 'waveChange',
  SHOW_SECTION_CHANGE: 'showSectionChange',
  CONFIDENCE_LEVEL_CHANGE: 'confidenceLevelChange',
  SECONDARY_CONFIDENCE_LEVEL_CHANGE: 'secondaryConfidenceLevelChange',
  COLORS_CHANGE: 'colorsChange',
  CHART_SCALE_CHANGE: 'chartScaleChange',
  CHART_TYPE_CHANGE: 'chartTypeChange',
  LEGEND_CLICK: 'legendClick',
  ELEMENT_TOGGLE: 'elementToggle',
  COLUMN_BLINK: 'blink',
  TIMELINE_UPDATE: 'timelineUpdate',
  SECTION_ADD: 'sectionAdd',
  SECTION_RENAME: 'sectionRename',
  SECTION_DELETE: 'sectionDelete',
  SECTION_REPLACE: 'sectionReplace',
  SECTION_APPLY_METRICS: 'sectionApplyMetrics',
  GROUP_ADD: 'groupAdd',
  REASSIGN_SIGTEST_LETTERS: 'reassignSigtestLetters',
  SHOW_FROM_TO_CHANGE: 'showFromToChange'
} as const

export type EventActionsType = (typeof EVENT_ACTIONS)[keyof typeof EVENT_ACTIONS]
